import React, { Component } from 'react'
import { connect } from 'react-redux'

class Historico extends Component {

    render(){
        const { historico } = this.props.documentos
 
        return(
            <div style={{ width: '100%', marginTop: 10 }}>
                <h5>Histórico:</h5>
                {historico && historico.historico.map( ( hist, index) => {
                    const { created_at, descricao, id } = hist
                    return ( 
                        <div id={id} key={id} style={{  marginBottom: 10, borderColor: 'green',borderLeft: '1.4px solid green',  }}                                    
                        >      
                            <div  style={styles.title} data-toggle={`collapse`} data-target={`#collapse${id}`} aria-expanded="true" aria-controls={`#collapse${id}`} >
                                <h6 className={'dropdown-toggle'} style={{ fontSize: 14, marginBottom: 0}}>{created_at}</h6>
                            </div>             

                            <div style={styles.descricao} id={`collapse${id}`} class="collapse">                                
                                {descricao}                                
                            </div>
                        </div> 
                    )
                })}
            </div>
        )
    }
}

const styles = {
    descricao: { padding: '2%', wordBreak: 'break-word', fontSize: 13},
    title: { cursor: 'pointer', padding: '8px',  background:'#f4f4f5'}
}

const mapStateToProps = ({ documentos }) => {
    return {
        documentos
    }
}

export default connect(mapStateToProps, {
    
})(Historico);

